import { TockLogoCore, TockLogoCoreProps } from './TockLogoCore';

const TockLogo = TockLogoCore;
export type TockLogoProps = TockLogoCoreProps;

export default TockLogo;
